/**
 * Development environment for the site build ('development' or 'production')
 */
export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENV;
/**
 * Service the code was built for ('shopify' or 'vercel')
 */
export const BUILD = process.env.NEXT_PUBLIC_BUILD;
/**
 * Flag for QBS Discount
 */
export const QBS_ENABLED = process.env.NEXT_PUBLIC_QBS_ENABLED === 'true';
